// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component, findDOMNode, PropTypes, Form as BaseForm } from '@plesk/ui-library';

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            state: null,
        };
    }

    handleSubmit = (values, isApply) => {
        Promise.resolve(typeof this.props.onSubmit === 'function' ? this.props.onSubmit(values) : true)
            .then(result => {
                if (result) {
                    const form = findDOMNode(this);

                    this.setState({
                        state: isApply ? 'apply' : 'submit',
                    });

                    new Ajax.Request(this.props.action || window.location.href, {
                        method: 'post',
                        parameters: $(form).serialize(),
                        onSuccess: this.handleSubmitSuccess,
                    });
                }
            });
    };

    handleSubmitSuccess = ({ responseJSON }) => {
        if (responseJSON.redirect) {
            if (this.state.state === 'apply') {
                document.location.reload();
            } else if (responseJSON.postData) {
                Jsw.redirectPost(responseJSON.redirect, responseJSON.postData, responseJSON.target);
            } else {
                Jsw.redirect(responseJSON.redirect, null, responseJSON.target);
            }
            return;
        }

        this.setState({
            state: null,
            errors: responseJSON.formMessages,
        });
    };

    render() {
        return (
            <BaseForm
                {...this.props}
                onSubmit={this.handleSubmit}
                errors={this.state.errors}
                state={this.state.state}
            />
        );
    }
}

Form.propTypes = {
    action: PropTypes.string.isRequired,
    onSubmit: PropTypes.func,
};

Form.defaultProps = {
    onSubmit: null,
};

export default Form;



// WEBPACK FOOTER //
// ./plesk/components/Form.js